import { useMemo } from "react";
import { transformTagsToTreeData } from "../utils/tagsDataUtils";
import { useTagsHierarchyViewer } from "../context";

/**
 * Custom hook for managing tags tabs functionality
 * @param {Object} toggledNodes - Object tracking which nodes are expanded
 * @returns {Object} Object containing tabs data, selected tab, handlers, and tree data
 */
export const useTagsTabs = (toggledNodes = {}) => {
  const { tags, tagTypes, selectedTabType, onTabChange, loading } =
    useTagsHierarchyViewer();

  const tabsList = useMemo(() => {
    return tagTypes.map((tab) => ({
      label: `${tab.name} (${tab.count})`,
      path: `#${tab.id}`,
      id: tab.id,
      onClick: () => onTabChange(tab.id),
      className: selectedTabType === tab.id ? "active" : "",
      "data-testid": `tab-${tab.id}`,
    }));
  }, [tagTypes, selectedTabType, onTabChange]);

  // Get filtered tags for selected tab
  const filteredTags = useMemo(() => {
    // Tags are already filtered by the selected tab type in the main component
    return tags;
  }, [tags]);

  // Transform filtered tags data into TreeView format
  const treeData = useMemo(() => {
    return transformTagsToTreeData(filteredTags, toggledNodes);
  }, [filteredTags, toggledNodes]);

  return {
    tabsList,
    selectedTabType,
    treeData,
    loading,
  };
};
